const baseUrl = 'https://apptrade.myfund.com:7103'
const baseUrl2 = 'http://app.myfund.com:8484' //app http://app.myfund.com:8484
const baseUrl3 = 'https://www.myfund.com'
const baseUrl4 = 'https://apptrade.myfund.com:9091'
const baseUrl5 = 'http://advisor.myfund.com'

let apiPath = {
    // 登录
    // 数据存储
    sessionId: baseUrl + '/appnew/LoginIn/getSessionResult',
    // 判断手机号是否绑卡或未绑卡是否注册
    judge: baseUrl + '/appnew/LoginIn/judge',
    // 只注册手机号的用户登录
    loginNumber: baseUrl + '/appnew/LoginIn/login',
    // 判断身份证是否已经被绑定过
    getOpenAccountStatus: baseUrl + '/appnew/LoginIn/getOpenAccountStatus',
    // 已开户的用户登录
    userLogin: baseUrl + '/appnew/LoginIn/userLogin', // 登录接口



    // 总资产信息
    allasset: baseUrl + '/appnew/assets/allasset',

    // 恒宝宝
    hbbasset: baseUrl + '/appnew/assets/hbbasset',
    getPrivatelyFloat: baseUrl + '/appnew/assets/getPrivatelyFloat', // 恒宝宝资产显示  私募线上
    getAccountInfo: baseUrl + '/appnew/user/getAccountInfo',
    // 恒宝宝累计收益汇总
    showMyDetails: baseUrl + '/appnew/assets/showMyDetails',
    // 恒宝宝累计收益汇总表
    showMyDetailsTable: baseUrl + '/appnew/assets/showMyDetails2',
    // 恒宝宝七日年化收益率折线图及近一月收益表格
    getOneMonth: baseUrl + '/appnew/assets/getOneMonth',
    // 查询系统银行卡信息项目调取一次，存入全局变量中
    getSysALLBankList: baseUrl + '/appnew/bankCard/getSysALLBankList',
    // 恒宝宝交易记录
    qeryPublicTrades: baseUrl + '/appnew/assets/qeryPublicTrades',
    // 单只记录确认时间
    hbbMessageInfo: baseUrl + '/appnew/info/hbbMessageInfo',
    // 恒宝宝撤单
    deleteTradesnew: baseUrl + '/appnew/trade/deleteTradesnew',
    //恒宝宝充值下单   下单接口，除与组合下单不同外，其它下单都为这个 1.立减券/appnew/trade/buyFundStepnewDES2  2.旧/appnew/member/buyFundStepnewDES2
    buyFundStepnewDES: baseUrl + '/appnew/trade/buyFundStepnewDES', //立减券和满减券
    //恒宝宝充值支付   支付接口，除与组合下单不同外，其它支付都为这个
    readyPayStepnew: baseUrl + '/appnew/trade/readyPayStepnew', //公募基金
    // 记录支付
    qeryBuyInfoBySheetNo: baseUrl + '/appnew/assets/qeryBuyInfoBySheetNo', //公募基金

    // 查询客户汇款银行卡信息
    getMyHKBankList: baseUrl + '/appnew/bankCard/getMyHKBankList',
    // 恒宝宝银行卡对应的账户信息
    getHbbbank: baseUrl + '/appnew/assets/getHbbbank',
    // 提现 基金卖出到银行卡 1.旧/appnew/trade/sellFund
    sellFundnew: baseUrl + '/appnew/trade/sellFundnew',
    // 恒宝宝提现结果
    qeryPublicTradesByNo: baseUrl + '/appnew/assets/qeryPublicTradesByNo',
    // 获取单只基金信息
    fundListone: baseUrl + '/appnew/assets/fundListone',
    //判断银行卡是否签约  公募基金  组合  新增鉴权查询接口 传参和checkBankInfoDES一样，返回三个字段status（是否有签约）fystatus（富友是否签约）hfstatus（汇付是否签约），0否1是
    checkBankInfoDES: baseUrl + '/appnew/bankCard/checkHfBankInfoDES', // 旧/appnew/bankCard/checkBankInfoDES
    // 验卡时，给对应手机号发送验证码 富友
    // identifySend: baseUrl + '/appnew/user/identifySend',
    // 银行关联手机号进行验卡 富友
    // verifySend: baseUrl + '/appnew/user/verifySend',
    // 定投旗下列表
    fundListFlag: baseUrl + '/appnew/trade/fundListFlag',
    // 定投列表
    searchSavePlanList: baseUrl + '/appnew/trade/searchSavePlanList',
    // 开通定投
    checkBeforeAutoSavePlan: baseUrl + '/appnew/trade/checkBeforeAutoSavePlan',
    // 终止定投
    deleteSavePlannew: baseUrl + '/appnew/trade/deleteSavePlannew',
    // 获取当前时间下单以后的确认份额日期或确认金额日期
    getFundDate: baseUrl + '/appnew/info/getFundDate',
    // 定投暂停
    periodicPaymentPause: baseUrl + '/appnew/trade/periodicPaymentPause',
    // 定投恢复
    periodicPaymentStart: baseUrl + '/appnew/trade/periodicPaymentStart',
    // 银行托收签约
    signSend: baseUrl + '/appnew/trade/signSend',
    // 定投修改
    getInvestment: baseUrl + '/appnew/trade/getInvestment',
    // 定投费率
    getRateFee: baseUrl + '/appnew/info/getRateFee',
    // 消息推送
    pushNewsModelContent: baseUrl + '/appnew/user/pushNewsModelContent',


    // 组合
    groupasset: baseUrl + '/appnew/assets/groupasset',
    // 组合持仓信息列表
    fundCombinationNew: baseUrl + '/appnew/moneyaccountController/fundCombinationNew',
    // 组合仓位差异相关   获取组合详细信息
    groupDetailList: baseUrl + '/appnew/assets/groupDetailList',
    // 组合是否可赎回判断
    getFenEshuHui: baseUrl + '/appnew/assets/getFenEshuHui',
    // 组合确认中列表   组合记录
    qeryBenchTrades: baseUrl + '/appnew/assets/qeryBenchTrades',
    // 基金组合确认中列表展开内容
    qeryBenchTradesInfo: baseUrl + '/appnew/assets/qeryBenchTradesInfo',
    // 组合下单
    groupBuyFundDES: baseUrl + '/appnew/trade/groupBuyFundDES',
    // 组合购买
    groupBuyFundreadyPayStep: baseUrl + '/appnew/trade/groupBuyFundreadyPayStep',
    // 展示组合名称
    groupfundList: baseUrl + '/appnew/info/groupfundList',
    // 获取组合交易信息
    benchRecordById: baseUrl + '/appnew/trade/benchRecordById',
    // 获取组合完成进度日期
    getGroupResult: baseUrl + '/appnew/trade/getGroupResult',
    // 组合卖出
    batSellFund: baseUrl + '/appnew/trade/batSellFund',
    // 组合预计费率、预计费用
    selectFree: baseUrl + '/appnew/info/selectFree',
    // 查询组合基金类型和占比
    benchAccounted: baseUrl + '/appnew/trade/benchAccounted',
    // 组合记录
    // pcGroupRecord: baseUrl + '/appnew/assets/pcGroupRecord',//旧
    pcGroupRecord: baseUrl + '/appnew/assets/groupRecord',
    // 组合撤单
    deleteTradesnew2: baseUrl + '/appnew/trade/deleteTradesnew2',
    // 组合持仓详情
    jingZhunChangeRecord: baseUrl + '/appnew/assets/jingZhunChangeRecord',
    // 组合持仓详情
    AppJingZhunCombineConfig: baseUrl2 + '/Service/DemoService.svc/AppJingZhunCombineConfig', //app
    // 智能投顾
    fundFilter: baseUrl + '/appnew/info/fundFilter', // 筛选基金接口
    // 组合每日收益
    selectprofitGroup: baseUrl + '/appnew/assets/selectprofitGroup',
    // 组合每日收益表格
    selectprofitGroupPage: baseUrl + '/appnew/assets/selectprofitGroupPage',

    // 组合调仓
    getPrecisionList: baseUrl + '/appnew/assets/getPrecisionList', // 调仓数据
    warehouseAdjustment: baseUrl + '/appnew/trade/warehouseAdjustment', // 精准调仓按钮
    getIntelligenceFundProportion: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetIntelligenceFundProportion', // 比例接口
    getTiaocangState: baseUrl4 + '/appwebnew/ws/webapp-cxf/getTiaocangState', // 调仓记录列表
    getRectification: baseUrl4 + '/appwebnew/ws/webapp-cxf/getRectification', // 调仓记录列表，单个组合
    getTiaocangIn: baseUrl4 + '/appwebnew/ws/webapp-cxf/getTiaocangIn', // 调仓记录详情
    getEstimatedFee: baseUrl4 + '/appwebnew/ws/webapp-cxf/getEstimatedFee', // 固定组合调仓费用
    getTiaocangNew: baseUrl + '/appnew/assets/getTiaocangNew', // 固定组合调仓按钮


    // 公募基金
    fundasset: baseUrl + '/appnew/assets/fundasset',
    // 公募基金持仓信息
    fundListNew: baseUrl + '/appnew/assets/fundListNew',
    // 公募基金记录
    qeryPublicTradesnew: baseUrl + '/appnew/assets/qeryPublicTradesnew',
    // 单只基金详情
    qerySingelDetailTrades: baseUrl + '/appnew/assets/qerySingelDetailTrades',
    // 恒宝宝购买基金下单  公募卖出到恒宝宝
    // 1.满减券/appnew/trade/sellChangeBuy'   2.旧/appnew/member/sellChangeBuy
    sellChangeBuynew: baseUrl + '/appnew/trade/sellChangeBuynew',
    // 基金收费方式
    shareType: baseUrl + '/appnew/trade/shareType',
    // 基金列表排行
    fundList: baseUrl + '/appnew/info/fundList',
    // 转换基金列表
    queryChangedFund: baseUrl + '/appnew/trade/queryChangedFund',
    // 基金转换
    changeFund: baseUrl + '/appnew/trade/changeFund',
    // 订单详情
    qeryPublicTradesByNoNew: baseUrl + '/appnew/trade/qeryPublicTradesByNoNew',
    // 查询转托管转入网点信息
    getTranBranchCode: baseUrl + '/appnew/assets/getTranBranchCode',
    // 分红设置
    setDefdividendMethod: baseUrl + '/appnew/assets/setDefdividendMethod',
    // 基金公司名称
    fundCompanyList: baseUrl + '/appnew/info/fundCompanyList',
    // 全局基金列表
    fundListSelect: baseUrl + '/appnew/assets/fundListSelect',
    // 判断基金是否第一次购买
    isfirstbuy: baseUrl + '/appnew/trade/isfirstbuy',
    // 公募累计收益
    fundTotalProfit: baseUrl + '/appnew/info/fundTotalProfit',
    getFundInfomationNewest: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetFundInfomationNewest', //基金公告



    // 私募
    selectFixPro: baseUrl + '/appnew/assets/selectFixPro', //私募固定收益类金额
    selectFloatPro: baseUrl + '/appnew/assets/selectFloatPro', //私募浮动收益资产  --  线下
    privateConfirmationNew: baseUrl + '/appnew/trade/privateConfirmationNew', //私募确认中
    // getPrivatelyFloat: baseUrl + '/appnew/assets/getPrivatelyFloat', //私募--线上
    // 私募记录
    privateTrlist: baseUrl + '/appnew/trade/privateTrlist',
    // 请求合同
    privateContract: baseUrl + '/appnew/trade/privateContract',
    // 转账凭证
    privateView: baseUrl + '/appnew/trade/privateView',



    // 优惠券
    queryCoupon: baseUrl + '/appnew/user/queryCoupon', // 可用卡券
    queryCouponRecord: baseUrl + '/appnew/user/queryCouponRecord', // 卡券列表
    backCoupon: baseUrl + '/appnew/member/backCoupon', //返还优惠券
    getExchange: baseUrl + '/appnew/member/getExchange', // 积分兑换
    // addIntegral: baseUrl + '/appnew/user/addIntegral', //旧


    /* 点财通会员 */
    listMember: baseUrl + '/appnew/member/listMember', // 点财通会员信息(未用)
    checkContract: baseUrl + '/appnew/member/checkContract', // 点财通会员信息
    checkDCTCard: baseUrl + '/appnew/member/checkDCTCard', // 点财通查询
    getUsIntegral: baseUrl + '/appnew/member/getUsIntegral', // 积分查询
    getIntegralWithPage: baseUrl + '/appnew/member/getIntegralWithPage', // 积分记录
    // getIntegral: baseUrl + '/appnew/member/getIntegral',//旧积分记录
    buyVipContract: baseUrl + '/appnew/user/buyVipContract', // 点财通续费新
    xfYearDCT: baseUrl + '/appnew/member/xfYearDCT', // 点财通会员卡支付
    orderPc: baseUrl + '/appnew/fy/orderPc', // 富友下单
    refundPc: baseUrl + '/appnew/fy/refundPc', // 点财通会员退款（测试）
    queryPc: baseUrl + '/appnew/fy/queryPc', // 点财通会员订单



    /* 我的诊断 */
    getIssue: baseUrl + '/appnew/user/getIssue', // 诊断报告
    wxPayOrder: baseUrl + '/appnew/wxPay/wxPayOrder', // 微信下单
    wxPayQuery: baseUrl + '/appnew/wxPay/wxPayQuery', // 微信查询
    selMoney: baseUrl + '/appnew/SpRanking/selMoney', // 诊断计费
    DiagnosticQA: baseUrl3 + '/webinterface/Bamboo.ashx?command=getUserFundAnalysisQuestionPCList', // 诊断问答



    /* 账户管理 */
    // 银行卡管理
    // getbankinfo: baseUrl + '/appnew/bankCard/getbankinfo', // 银行卡详情
    updDdefault: baseUrl + '/appnew/moneyaccountController/updDdefault', // 修改默认银行卡
    deleteBank: baseUrl + '/appnew/bankCard/deleteBank', // 删除银行卡
    getChangeBankMessage: baseUrl + '/appnew/bankCard/getChangeBankMessage', // 换卡记录
    bank: baseUrl + '/appnew/bankCard/bank', // 银行卡类型验证  1、增加hfchannelid（汇付的channelid）字段
    // 银行卡 增加字段hfsignresult（汇付是否签约）如果签了汇付，则返回的限额和channelid都是汇付的 旧/appnew/bankCard/getMyALLBankList
    // getMyALLBankList: baseUrl + '/appnew/bankCard/getMyActiveBankListnew',
    // getBankLimit: baseUrl + '/appnew/bankCard/getBankLimit', // 银行卡限额
    // 汇付接口
    // getHfBankLimit: baseUrl + '/appnew/hf/getHfBankLimit', // 汇付限额查询
    // hfidentifySend: baseUrl + '/appnew/hf/identifySend', // 汇付获取短信验证码
    // hfverifySend: baseUrl + '/appnew/hf/verifySend', // 汇付绑卡
    // hfreadyPay: baseUrl + '/appnew/hf/readyPay', // 汇付支付
    hfquery: baseUrl + '/appnew/hf/query', // 汇付查询结果
    // 支付路由（富友，汇付）
    bankList: baseUrl + '/appnew/pay/bankList',             // 获取银行列表
    channelList: baseUrl + '/appnew/pay/channelList',       // 获取渠道信息（按需使用）
    limit: baseUrl + '/appnew/pay/limit',                   // 获取限额信息（按需使用）
    myBankList: baseUrl + '/appnew/pay/myBankList',         // 我的银行卡列表
    addBank: baseUrl + '/appnew/pay/addBank',               // 添加银行卡 旧：/appnew/bankCard/addBank
    addChannel: baseUrl + '/appnew/pay/addChannel',         // 添加新渠道
    defaultChannel: baseUrl + '/appnew/pay/defaultChannel', // 修改默认渠道
    identifySend: baseUrl + '/appnew/pay/identifySend',     // 发送验证码
    verifySend: baseUrl + '/appnew/pay/verifySend',         // 签约
    readyPay: baseUrl + '/appnew/pay/readyPay',             // 支付


    // 个人信息完善
    saveIdPic: baseUrl + '/appnew/user/saveIdPic', // 保存身份证信息
    identifyOcr: baseUrl + '/appnew/user/identifyOcr', // 身份证识别
    saveAllInfo: baseUrl + '/appnew/user/saveAllInfo', // 保存用户信息
    queryAllInfo: baseUrl + '/appnew/user/queryAllInfo', // 获取用户信息
    // 风险测评
    getQuestion: baseUrl + '/appnew/info/getQuestion', // 获取风险测评问题
    updateAccountRiskLevel: baseUrl + '/appnew/info/updateAccountRiskLevel', // 提交风险测评结果
    modification: baseUrl + '/appnew/user/modification', // 保持风险登记
    // 密码
    resetTPassword: baseUrl + '/appnew/user/resetTPassword', // 修改密码
    checkInfo: baseUrl + '/appnew/user/checkInfo', // 检查用户信息
    smsMessageSend: baseUrl + '/appnew/user/sendSMS', //发送短信验证码
    // smsMessageSend: baseUrl + '/appnew/user/smsMessageSend', //发送短信验证码    2024.11.1 更换短信接口名字为：sendSMS
    updPass: baseUrl + '/appnew/LoginIn/updPass', // 未开户修改密码


    // 开户流程
    regist: baseUrl + '/appnew/LoginIn/regist', //注册
    openAccount: baseUrl + '/appnew/user/openAccount', // 开户
    openwebsite: baseUrl + '/appnew/user/openwebsite', // 添加开户信息
    openAccountSimu: baseUrl + '/appnew/user/openAccountSimu', // 私募开户
    sendMailNew: baseUrl + '/appnew/user/sendMailNew', // 发送邮件


    // 全局
    getAnnouncementPC: baseUrl + '/appnew/user/getAnnouncementPC', // 公告


    // xyy：我的自选
    searchFund: baseUrl3 + '/webinterface/Bamboo.ashx?command=search_index', // 搜索基金
    addSearchFund: baseUrl3 + '/webinterface/Bamboo.ashx?command=AddedFundCenter', // 添加搜索基金
    getChoiceType: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetFundCenterGroup', // 获取自选分类
    addChoiceType: baseUrl3 + '/webinterface/Bamboo.ashx?command=CreateCenterGroup', // 新建自选分类
    editChoiceType: baseUrl3 + '/webinterface/Bamboo.ashx?command=RechristenCenterGroup', // 更改自选分类
    delChoiceType: baseUrl3 + '/webinterface/Bamboo.ashx?command=DeleteCenterGroup', // 删除自选分类
    moveChoiceType: baseUrl3 + '/webinterface/Bamboo.ashx?command=MoveFundCenterGroup', // 上下移位
    getChoiceList: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetFundCenterList', // 获取自选列表_基金概况
    getChoiceYield: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetFundCenterYield', // 获取自选列表_业绩排名
    delFundCodes: baseUrl3 + '/webinterface/Bamboo.ashx?command=DeleteFundCenter', // 删除基金
    goTopFund: baseUrl3 + '/webinterface/Bamboo.ashx?command=TopFundCenter', // 置顶基金
    getChoiceFundStatus: baseUrl3 + '/webinterface/Bamboo.ashx?command=getFundStatus', // 获取基金购买状态


    // 优选50
    best50New: baseUrl3 + '/webinterface/Bamboo.ashx?command=getTop3ofBest50New1', // 优选50基金



    pushNewsModelSuggestApp: baseUrl + '/appnew/user/pushNewsModelSuggestApp', // 意见反馈

    // 我的顾问
    advisorRecommend: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserRecommend', // 理财顾问推荐
    myFollowLists: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserFollowList', // 理财顾问关注列表
    adviserShare: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserShare', // 理财顾问投资分享
    adviserArchives: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserArchives', // 理财顾问档案
    adviserRelation: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserRelation', // 理财顾问绑定
    ChangeFocusStatus: baseUrl3 + '/webinterface/Bamboo.ashx?command=UpdateInvestmentAdviserFollow', // 更改关注状态
    judgeFollow: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetInvestmentAdviserFollow', // 判断是否关注理财顾问
    applyAdviser: baseUrl3 + '/webinterface/Bamboo.ashx?command=UpdateInvestmentAdviserRelation', // 申请理财顾问
    adviserMessage: baseUrl3 + '/webinterface/Bamboo.ashx?command=AddedInvestmentAdviserMessage', // 新增理财顾问留言

    // 相关协议
    getFundDetailInfo3: baseUrl3 + '/webinterface/Bamboo.ashx?command=GetFundDetailInfo3', //风险揭示书

    // 消息中心
    getPushListPC: baseUrl + '/appnew/user/getPushListPC', //获取分类数据
    updatePushNumPC: baseUrl + '/appnew/user/updatePushNumPC', //阅读、删除 flag（0-阅读，1-删除）
    clearMessagePush: baseUrl + '/appnew/user/clearMessagePush', //清空  flag(0-未读，1-已读,2-全部)
    isReadMessage: baseUrl + '/appnew/user/isReadMessage', //判断各种类型是否有未读信息


    // 清算调账
    searchAvgMoney: baseUrl + '/appnew/trade/searchAvgMoney',   //月度日均存量计算
    searchyhqlist: baseUrl + '/appnew/trade/searchyhqlist',     //使用优惠券购买详情
    liquidation: baseUrl + '/appnew/trade/liquidation',         //赎回转申认购调账
    liquidation1: baseUrl + '/appnew/trade/liquidation1',       //组合持仓清算
    liquidation2: baseUrl + '/appnew/trade/liquidation2',       //客户资产清算
    liquidation3: baseUrl + '/appnew/trade/liquidation3',       //组合下单调账


    //顾问推荐
    GetAdvisorRemmondedList: baseUrl5 + '/Api/GetAdvisorRemmondedList',
    GetAdvisorList: baseUrl5 + '/Api/GetAdvisorList',   //顾问列表带分页
    SerchAdvisorList: baseUrl5 + '/Api/SerchAdvisorList',   //顾问搜索
    //私募基金单页
    GetFundInfo: baseUrl + '/appnew/pfund/app/GetFundInfo',  //私募基金基本信息  不用了
    GetFundBasisInfo: baseUrl + '/appnew/pfund/app/GetFundBasisInfo',  //私募基金基本信息  不用了
    Fund_detail:baseUrl + '/appnew/pfund/web/Fund_detail', //私募基金基本信息
    Fund_Recommend:baseUrl3 + "/webinterface/Bamboo.ashx?command=Fund_Recommend", //热销私募
    ws_sendMailNew:"https://apptrade.myfund.com:9091/appwebnew/ws/webapp-cxf/sendMailNew",  //预约咨询
    // ws_sendMailNewaa: "https://apptrade.myfund.com:7103/appnew/user/sendMailNew",  //预约咨询  这个接口是测试数据  todo
    checkPhoneExists:baseUrl3 + "/webinterface/Bamboo.ashx?command=checkPhoneExists",//验证手机号是否正确
    checkUserInfo: baseUrl3 + "/webinterface/Bamboo.ashx?command=checkUserInfo",//验证手机号是否正确
    get_noteCode: baseUrl3 + "/webinterface/Bamboo.ashx?command=get_noteCode", //获取短信验证码
    updatePassword: baseUrl3 + "/webinterface/Bamboo.ashx?command=updatePassword", //提交忘记密码操作
    register: baseUrl3 + "/webinterface/Bamboo.ashx?command=register", //注册操作
    PrivateFundHistoryNetValue: baseUrl + '/appnew/pfund/web/PrivateFundHistoryNetValue', //净值表现表格
    PrivateFundNetValue: baseUrl + '/appnew/pfund/web/PrivateFundNetValue', //净值表现图
    PrivateFundPerformance: baseUrl + '/appnew/pfund/web/PrivateFundPerformance', //综合指标
    PrivateFundPhaseYield: baseUrl + '/appnew/pfund/web/PrivateFundPhaseYield', //区间收益
    PrivateFundRiskIndex: baseUrl + '/appnew/pfund/web/PrivateFundRiskIndex', //区间风险

};

export default apiPath;
